import { render, staticRenderFns } from "./ModalEstadoConservacaoIBP.vue?vue&type=template&id=56e28fb4"
import script from "./ModalEstadoConservacaoIBP.vue?vue&type=script&lang=js"
export * from "./ModalEstadoConservacaoIBP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports